<p-floatlabel variant="on">
  <input [autocomplete]="autocomplete()" [formControl]="control()"
         [invalid]="this.control().invalid && this.control().touched" [type]="type()" fluid
         pInputText/>
  <label for="in_label">
    {{ label() }}
    @if (isRequired()) {
      <span class="text-red-500">*</span>
    }
  </label>
</p-floatlabel>
@if (this.control().invalid && this.control().touched) {
  @if (this.control().hasError('required')) {
    <p-message severity="error" size="small" variant="simple">{{ 'error.required' | translate }}</p-message>
  }
  @if (this.control().hasError('email')) {
    <p-message severity="error" size="small" variant="simple">{{ 'error.email' | translate }}</p-message>
  }
  @if (this.control().hasError('belgianVat')) {
    <p-message severity="error" size="small" variant="simple">{{ 'error.belgian-vat' | translate }}</p-message>
  }
}


